import { FC } from 'react';

import {
  IModifierData,
  ModifierType,
} from 'features/menu/components/product-detail/modifier/types';
import { MultipliersSelections } from 'features/menu/components/product-wizard/types';

import { ProductCardDisabled } from 'components/product-card/product-card-disabled';

import { ModifierCheckbox } from './modifier-checkbox';
import { ModifierMultipleChoices } from './modifier-multiple-choices';
import { ModifierNonNumeric } from './modifier-non-numeric';
import { ModifierSingleChoice } from './modifier-single-choice';

export interface IModifierProps extends IModifierData {
  onSelectionsChange: (selections: MultipliersSelections) => void;
}

export const Modifier: FC<IModifierProps> = props => {
  const { modifier } = props;

  if (modifier.disabled) {
    return <ProductCardDisabled name={modifier.name} image={modifier.image} />;
  }

  switch (modifier.type) {
    case ModifierType.NON_NUMERIC:
      return <ModifierNonNumeric {...props} />;
    case ModifierType.CHECKBOX:
      return <ModifierCheckbox {...props} />;
    case ModifierType.NUMERIC:
      return null;
    case ModifierType.SINGLE_CHOICE:
      return <ModifierSingleChoice {...props} />;
    case ModifierType.MULTIPLE_CHOICE:
      return <ModifierMultipleChoices {...props} />;
    default:
      return null;
  }
};
